import React, { useState } from "react";
import './Faqs.css';
import q from "../assets/images/faqs.png";

const Faqs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "How long does the company registration process take?",
      answer:
        "The company registration process typically takes 7 to 14 business days, depending on the business structure [e.g., INDIA ( Private Limited, LLP, OPC ), US ( LLC, S-Corp, or C-Corp )] and specific regulatory requirements. Our team handles all documentation, approvals, and filings to ensure a smooth and timely process.",
    },
    {
      question: "What services are included in your startup packages?",
      answer:
        "Our startup packages are tailored to your needs and include legal structure guidance, company formation [ INDIA ( Private Limited, LLP, OPC ), US ( LLC, S-Corp, or C-Corp )], trademark and copyright assistance, regulatory compliance, tax registration (e.g., GST, EIN), and accounting system setup to help you launch with confidence.",
    },
    {
      question: "Do you assist with GST and tax compliance?",
      answer:
        "Yes, we provide end-to-end GST registration, filing, and tax compliance services for businesses in India, as well as federal and state tax filings in the US. We also offer tax planning and audit support to optimize your financial strategy and ensure full compliance.",
    },
    {
      question: "What web development services do you provide?",
      answer:
        "We offer custom web development, including responsive websites, e-commerce platforms, and web applications. Our services also include SEO optimization, secure hosting, and post-launch maintenance, such as updates, backups, and performance tuning, to keep your site running smoothly.",
    },
    {
      question: "What industries do you cater to?",
      answer:
        "We cater to a wide range of industries, including startups, small businesses, e-commerce ventures, tech firms, professional services, hospitality, healthcare, and education. Our solutions are customized to meet the unique needs of each sector.",
    },
    {
      question: "What is included in your virtual CFO services?",
      answer:
        "Our virtual CFO services are designed for startups and small businesses, offering cash flow management, financial planning, budgeting, forecasting, investor-ready financial reporting, and strategic advice to help you make informed decisions and achieve growth.",
    },
    {
      question: "Do you offer digital marketing services?",
      answer:
        "Yes, we provide comprehensive digital marketing services, including SEO, content marketing, social media strategy, paid ad campaigns (Meta, Google), email marketing, and analytics. We help you grow your online presence and drive measurable results.",
    },
    {
      question: "Can you assist with business plan creation?",
      answer:
        "Yes, we specialize in creating detailed, investor-ready business plans. These include market analysis, competitive research, operational strategies, financial projections, and growth roadmaps to help you secure funding or streamline your operations.",
    },
    {
      question: "What compliance services do you offer?",
      answer:
        "We provide a full range of compliance services, including ROC filings, tax audits, TDS compliance, PF/ESI registrations, and annual compliance support for businesses in India and the US. We ensure your business adheres to all legal and regulatory requirements.",
    },
    {
      question: "Do you offer international business support?",
      answer:
        "Yes, we support international businesses with tax compliance, cross-border accounting, regulatory requirements, and market entry strategies. Whether you’re expanding into India, the US, or other regions, we ensure smooth operations.",
    },
    {
      question: "What is your approach to trademark and copyright protection?",
      answer:
        "We offer comprehensive trademark and copyright registration services, including searches, filings, and legal guidance for both local (MCA, USPTO) and international markets. Our goal is to protect your brand identity and intellectual property globally.",
    },
    {
      question: "Can you assist with fundraising for startups?",
      answer:
        "Yes, we help startups secure funding by preparing investor-ready business plans, pitch decks, financial models, and valuation reports. We also provide guidance on pitching to investors and navigating funding rounds.",
    },
    {
      question: "What payment options are available for your services?",
      answer:
        "We offer flexible payment options, including credit/debit cards, net banking, UPI, digital wallets (e.g., PayPal, Razorpay), and bank transfers. All transactions are secure and tailored to your convenience.",
    },
    {
      question: "What resources do you provide for startups?",
      answer:
        "We provide a variety of resources for startups, including templates for business plans and financial models, guides on compliance and marketing, and one-on-one consultations to help you navigate the early stages of your business journey.",
    },
    {
      question: "How can I contact your team?",
      answer:
        "You can reach us via email at support@krinvy.com, call us at +91-XXXX-XXXXXX, or message us through our WhatsApp chat button on the website. Our team is available Monday to Saturday, 9 AM to 6 PM IST, to assist with all your inquiries.",
    },
    {
      question: "Is there a refund policy for your services?",
      answer:
        "Yes, we offer a transparent refund policy. If you’re not satisfied with our services, contact us within 30 days of purchase. We’ll work to resolve your concerns, and if necessary, process a refund as per our terms and conditions.",
    },
    {
      question: "What branding and design services do you offer?",
      answer:
        "We provide logo design, brand identity creation, pitch decks, marketing materials, and packaging design. Our services are tailored to create a cohesive and impactful visual identity for your business.",
    },
    {
      question: "How do you support e-commerce businesses?",
      answer:
        "We offer tailored e-commerce growth solutions, including website development, funnel optimization, retargeting strategies, email/SMS campaigns, and digital marketing to help you increase sales and retain customers.",
    },
    {
      question: "What HR and recruitment support do you provide?",
      answer:
        "We assist with job postings, candidate sourcing, offer letter preparation, HR policy drafting, ATS integration, payroll setup, and employee onboarding to streamline your hiring process.",
    },
    {
      question: "Do you provide website and IT maintenance services?",
      answer:
        "Yes, we offer ongoing website and IT maintenance, including security updates, backups, bug fixes, performance tuning, 24/7 monitoring, and analytics reporting to ensure your digital assets run smoothly.",
    },
    {
      question: "What offline marketing services do you offer?",
      answer:
        "We design eye-catching offline marketing materials, such as brochures, hoardings, restaurant menus, flyers, office signage, and promotional merchandise, to enhance your local brand presence.",
    },
    {
      question: "Can you help with content and copywriting?",
      answer:
        "Yes, we provide SEO-friendly content creation, including website content, blog posts, ad copy, sales emails, and product descriptions, to engage your audience and drive conversions.",
    },
    {
      question: "What social media management services do you offer?",
      answer:
        "We offer strategic social media management, including content creation (posts, reels), influencer collaborations, paid ad campaigns (Meta, Instagram), and analytics to grow your online presence.",
    },
    {
      question: "Do you provide IT and software solutions?",
      answer:
        "Yes, we develop custom software, CRM systems, cloud solutions, and provide IT consulting to improve business efficiency and scalability, tailored to your specific needs.",
    },
    {
      question: "How do you ensure the quality of your services?",
      answer:
        "We ensure quality through a rigorous process that includes experienced professionals, regular progress updates, client feedback, and adherence to industry best practices, reflecting our core value of Excellence.",
    },
    {
      question: "Can you help with business strategy and consulting?",
      answer:
        "Yes, we offer business strategy and consulting services, including growth roadmaps, market entry strategies, funding plans, and legal structuring advice for businesses in India, the US, and beyond.",
    },
  ];

  return (
    <div className="faqs-container">
      <div className="faqs-header">
        <h2 className="faqs-heading">Got Questions?</h2>
        <h3 className="faqs-subheading">Everything you need to know before you begin.</h3>
        <img 
          src={q} 
          alt="Business Growth with Krinvy"
          className="faqs-image" 
        />
      </div>

      <div className="faqs-accordion">
        {faqs.map((faq, index) => (
          <div 
            key={index} 
            className={`faqs-item ${activeIndex === index ? 'active' : ''}`}
          >
            <button 
              className="faqs-question"
              onClick={() => toggleAccordion(index)}
              aria-expanded={activeIndex === index}
            >
              <h3>{faq.question}</h3>
              <span className="faqs-icon">
                {activeIndex === index ? '−' : '+'}
              </span>
            </button>
            <div className="faqs-answer">
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faqs;